import { memo } from "react";
import { Link } from "react-router-dom";

import styled from "styled-components";

import MenuItem from "@mui/material/MenuItem";

import LogoIcon from "../Icon/Logo";

// -----------------------------------------------------------------------------

const HeaderLogo = memo(function HeaderLogo() {
  return (
    <MenuItemStyled disableRipple disableTouchRipple disableGutters>
      <LinkedStyled to="/">
        <LogoIconStyled />
      </LinkedStyled>
    </MenuItemStyled>
  );
});

export default HeaderLogo;

// -----------------------------------------------------------------------------

const MenuItemStyled = styled(MenuItem)`
  &:hover {
    background: none !important;
  }
`;

const LinkedStyled = styled(Link)`
  display: flex;
`;

const LogoIconStyled = styled(LogoIcon)`
  height: 40px !important;
  padding: 0;
  width: 140px !important;

  path {
    fill: #fff;
  }
`;
